package org.gymly.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable

/** Textos de Asistencia y sesiones (reservas + registro manual de visitas de piso). */
interface BookingsStrings {
    val visitRegisterTitle: String
    val visitRegisterHint: String
    val visitRegisterButton: String
    val visitCreateFailed: String
    val visitAlreadyRegisteredClient: String
    val visitAlreadyRegisteredStaff: String
    val errSelectClient: String
    val errSelectWorker: String
    val errSelectSchedule: String
    val loadFailed: String
    val markAttendedFailed: String
    val markNoShowFailed: String
    val bookingCreateFailed: String
    val bookingSaveFailed: String
    val bookingDeleteFailed: String
    val visitDeleteFailed: String
    val deleteBookingTitle: String
    fun deleteBookingConfirm(clientName: String): String
    val deleteVisitTitle: String
    fun deleteVisitConfirm(subjectName: String, date: String): String

    /** Traduce códigos o textos conocidos del API al idioma de la UI. */
    fun localizeApiError(raw: String): String = alertStrings().localize(raw)
}

internal object BookingsEs : BookingsStrings {
    override val visitRegisterTitle = "Registrar sesión (manual)"
    override val visitRegisterHint =
        "Úsalo cuando el terminal no esté activo. Un registro por persona y día (cliente o trabajador)."
    override val visitRegisterButton = "+ Registrar sesión"
    override val visitCreateFailed = "No se pudo registrar la sesión."
    override val visitAlreadyRegisteredClient = "Ya se registró la sesión de este cliente hoy."
    override val visitAlreadyRegisteredStaff = "Ya se registró la sesión de este trabajador hoy."
    override val errSelectClient = "Selecciona un cliente."
    override val errSelectWorker = "Selecciona un trabajador."
    override val errSelectSchedule = "Selecciona una franja."
    override val loadFailed = "No se pudieron cargar las sesiones."
    override val markAttendedFailed = "No se pudo marcar la asistencia."
    override val markNoShowFailed = "No se pudo marcar la no asistencia."
    override val bookingCreateFailed = "No se pudo crear la reserva."
    override val bookingSaveFailed = "No se pudo guardar la reserva."
    override val bookingDeleteFailed = "No se pudo eliminar la reserva."
    override val visitDeleteFailed = "No se pudo eliminar la sesión."
    override val deleteBookingTitle = "Eliminar reserva"
    override fun deleteBookingConfirm(clientName: String) =
        "¿Seguro que deseas eliminar la reserva de $clientName? Esta acción no se puede deshacer."
    override val deleteVisitTitle = "Eliminar sesión"
    override fun deleteVisitConfirm(subjectName: String, date: String) =
        "¿Eliminar la sesión de $subjectName del $date?"
}

internal object BookingsEn : BookingsStrings {
    override val visitRegisterTitle = "Register session (manual)"
    override val visitRegisterHint =
        "Use this when the terminal is offline. One check-in per person per day (member or staff)."
    override val visitRegisterButton = "+ Register session"
    override val visitCreateFailed = "Could not register the session."
    override val visitAlreadyRegisteredClient = "This client already has a session registered today."
    override val visitAlreadyRegisteredStaff = "This worker already has a session registered today."
    override val errSelectClient = "Select a client."
    override val errSelectWorker = "Select a worker."
    override val errSelectSchedule = "Select a time slot."
    override val loadFailed = "Could not load the sessions."
    override val markAttendedFailed = "Could not mark attendance."
    override val markNoShowFailed = "Could not mark as no-show."
    override val bookingCreateFailed = "Could not create the booking."
    override val bookingSaveFailed = "Could not save the booking."
    override val bookingDeleteFailed = "Could not delete the booking."
    override val visitDeleteFailed = "Could not delete the session."
    override val deleteBookingTitle = "Delete booking"
    override fun deleteBookingConfirm(clientName: String) =
        "Are you sure you want to delete the booking for $clientName? This cannot be undone."
    override val deleteVisitTitle = "Delete session"
    override fun deleteVisitConfirm(subjectName: String, date: String) =
        "Delete the session for $subjectName on $date?"
}

@Composable
@ReadOnlyComposable
fun bookingsStrings(): BookingsStrings = pickStrings(BookingsEs, BookingsEn)
